var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.05622 24.4742L11.9499 19.4681",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4247 9.78767L21.5637 9.92073L24.675 12.8998C25.2136 13.4154 25.2321 14.27 24.7165 14.8085L23.2986 16.2894C22.7829 16.8279 21.9284 16.8465 21.3898 16.3309L20.9203 15.8813L19.0884 17.7947C19.2589 18.3836 19.5264 19.4421 19.6279 20.596C19.7715 22.2282 19.3819 23.4613 18.8797 24.2522C18.3846 25.0317 17.4111 24.9409 16.9084 24.4596L12.0746 19.8313L11.9356 19.6982L7.10173 15.0698C6.59901 14.5885 6.46607 13.6199 7.22336 13.0914C7.99168 12.5553 9.20673 12.1125 10.8436 12.1852C12.0009 12.2365 13.0699 12.4577 13.6657 12.6025L15.4977 10.6892L15.0282 10.2397C14.4897 9.72408 14.4711 8.8695 14.9867 8.33097L16.4047 6.85008C16.9203 6.31154 17.7749 6.29299 18.3134 6.80862L21.4247 9.78767ZM20.249 11.0156L17.3905 8.27858L16.4567 9.25387L16.9262 9.7034C17.4647 10.219 17.4833 11.0736 16.9676 11.6121L14.7589 13.9189C14.4079 14.2855 13.8942 14.4153 13.4268 14.2951C12.9408 14.1701 11.8896 13.9332 10.7682 13.8835C9.84772 13.8426 9.15533 14.01 8.67378 14.2214L13.1113 18.4703L13.2503 18.6034L17.6878 22.8522C17.878 22.3619 18.0152 21.6629 17.9344 20.745C17.836 19.6268 17.5538 18.587 17.4078 18.1069C17.2674 17.6451 17.3748 17.1262 17.7258 16.7596L19.9345 14.4528C20.4501 13.9143 21.3047 13.8958 21.8432 14.4114L22.3127 14.8609L23.2465 13.8856L20.388 11.1486L20.249 11.0156Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinDefault);
export default __webpack_public_path__ + "static/media/pin-default.6e797e85b09eba196a01c0e37430bb1b.svg";
export { ForwardRef as ReactComponent };